import PropTypes from 'prop-types';
import { clsx } from 'clsx';

const variantStyles = {
  primary: 'bg-accent text-tertiary hover:bg-hover active:bg-pressed',
  secondary: 'border border-border-default text-primary hover:bg-bg-hover',
  destructive:
    'border border-error text-error hover:bg-error hover:text-primary',
  ghost: 'text-primary hover:bg-bg-hover',
};

const sizeStyles = {
  sm: 'py-spacing-1 px-spacing-2 text-dls-small',
  md: 'py-spacing-1 px-spacing-3 text-dls-body',
  lg: 'py-spacing-2 px-spacing-4 text-dls-body',
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  icon = null,
  iconRight = null,
  className = '',
  onClick,
  onFocus,
  onBlur,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      className={clsx(
        'inline-flex items-center justify-center gap-spacing-2',
        'rounded font-normal h-8',
        'transition-colors duration-200',
        'focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none',
        sizeStyles[size],
        fullWidth && 'w-full',
        disabled ? 'opacity-50 cursor-not-allowed' : variantStyles[variant],
        className
      )}
      {...props}
    >
      {icon && <span className="size-4">{icon}</span>}
      {children}
      {iconRight && <span className="size-4">{iconRight}</span>}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'destructive', 'ghost']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  iconRight: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  'aria-label': PropTypes.string,
  'aria-describedby': PropTypes.string,
  type: PropTypes.string,
};
